import { render, staticRenderFns } from "./StorageDetails.vue?vue&type=template&id=a9ae0b7e&scoped=true&"
import script from "./StorageDetails.vue?vue&type=script&lang=js&"
export * from "./StorageDetails.vue?vue&type=script&lang=js&"
import style0 from "./StorageDetails.vue?vue&type=style&index=0&id=a9ae0b7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ae0b7e",
  null
  
)

export default component.exports